import { render, staticRenderFns } from "./AbkAttachmentInput.vue?vue&type=template&id=6287e225&scoped=true&"
import script from "./AbkAttachmentInput.vue?vue&type=script&lang=js&"
export * from "./AbkAttachmentInput.vue?vue&type=script&lang=js&"
import style0 from "./AbkAttachmentInput.vue?vue&type=style&index=0&id=6287e225&scoped=true&lang=scss&"
import style1 from "./AbkAttachmentInput.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287e225",
  null
  
)

export default component.exports